/**
 * SkipLink — "Saltar al contenido principal" (WCAG 2.4.1 Bypass Blocks, nivel A).
 *
 * Link oculto visualmente que se revela al recibir foco vía Tab desde la
 * primera posición del DOM. Permite a usuarios de teclado y lectores de
 * pantalla saltar la navegación repetida (navbar) y aterrizar directamente
 * en `#main` del layout activo.
 *
 * Cada layout (MainLayout/AdminLayout/CuentaLayout/AuthLayout) renderiza
 * `<SkipLink />` como primer hijo del wrapper y un `<main id="main"
 * tabIndex={-1}>` como target. El `tabIndex={-1}` es necesario para que el
 * focus programático funcione en Safari/Firefox sin convertirlo en parada
 * del Tab natural.
 */
export function SkipLink() {
  return (
    <a
      href="#main"
      className={[
        // Oculto por defecto: posicionado fuera de pantalla con sr-only.
        'sr-only',
        // Cuando recibe foco se vuelve visible y se ancla arriba a la izquierda.
        'focus:not-sr-only',
        'focus:fixed focus:top-4 focus:left-4 focus:z-[100]',
        'focus:bg-primary-700 focus:text-cream-50',
        'focus:px-4 focus:py-2 focus:rounded-md',
        'focus:text-button focus:font-body',
        'focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-gold-500',
      ].join(' ')}
    >
      Saltar al contenido
    </a>
  );
}
